import React from 'react';

export function ColumnsOutlineIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
      <g clipPath="url(#clip0_1_256)">
        <path
          d="M7.87207 2.87219V17.8722M12.8721 2.87219V17.8722M2.87207 3.70553C2.87207 3.48451 2.95987 3.27255 3.11615 3.11627C3.27243 2.95999 3.48439 2.87219 3.7054 2.87219H17.0387C17.2597 2.87219 17.4717 2.95999 17.628 3.11627C17.7843 3.27255 17.8721 3.48451 17.8721 3.70553V17.0389C17.8721 17.2599 17.7843 17.4718 17.628 17.6281C17.4717 17.7844 17.2597 17.8722 17.0387 17.8722H3.7054C3.48439 17.8722 3.27243 17.7844 3.11615 17.6281C2.95987 17.4718 2.87207 17.2599 2.87207 17.0389V3.70553Z"
          stroke="#767676"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1_256">
          <rect width="20" height="20" fill="white" transform="translate(0.37207 0.37207)" />
        </clipPath>
      </defs>
    </svg>
  );
}
